import { Injectable } from '@angular/core';
import { PermissionsService } from 'src/app/service/auth/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class JobPointePermissionsService {
  constructor(private permissionsService: PermissionsService) {}

  isAllowed(row: any, resource1: string, action: string) {
    return this.permissionsService.allow({ resource1, action });
  }
}
